export default __webpack_public_path__ + "static/drag-5a0ef72c7245b71c50c0174e069942cd.png";